import { render, staticRenderFns } from "./AgencyWorkIcon.vue?vue&type=template&id=50207b0c"
import script from "./AgencyWorkIcon.vue?vue&type=script&lang=js"
export * from "./AgencyWorkIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports